import {I18n} from "react-redux-i18n";
import { interfaceDataTypes, interfaceHistoryConfig, interfaceType } from "./InterfaceUtils";

export function getDropdown(dropdown) {
    switch (dropdown) {
        case "dataType":
            return [{
                value: interfaceDataTypes.METADATA, 
                label: I18n.t("interfaces.dataTypes.metadata")
            }, {
                value: interfaceDataTypes.STRING, 
                label: I18n.t("interfaces.dataTypes.string")
            }, {
                value: interfaceDataTypes.NUMERIC, 
                label: I18n.t("interfaces.dataTypes.numeric")
            }, {
                value: interfaceDataTypes.BOOLEAN, 
                label: I18n.t("interfaces.dataTypes.boolean")
            }];
        case "historyConfiguration":
            return [{
                value: interfaceHistoryConfig.NO_HISTORY, 
                label: I18n.t("interfaces.historyConfiguration.noHistory")
            }, {
                value: interfaceHistoryConfig.DIFFERENT_VALUES, 
                label: I18n.t("interfaces.historyConfiguration.differentValues")
            }, {
                value: interfaceHistoryConfig.ALL_VALUES, 
                label: I18n.t("interfaces.historyConfiguration.allValues")
            }];
        case "interfaceType":
            return [{
                value: interfaceType.IN, 
                label: I18n.t("interfaces.interfaceType.input")
            }, {
                value: interfaceType.OUT, 
                label: I18n.t("interfaces.interfaceType.output")
            }, {
                value: interfaceType.IN_OUT, 
                label: I18n.t("interfaces.interfaceType.inputOutput")
            }];
        default:
            return [];
    }
}